
export function initHomeOnline(main: HTMLElement) {

	main.querySelectorAll('[data-part="start"]').forEach(
		(d) => {
			d.addEventListener('click', (e) => {
				window['OJNew'].showFreeCoursePopup();
				e.preventDefault();
			})
		}
	)




}
